module.exports = __webpack_public_path__ + "static/media/work_with_us_team.a32ee19e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work_with_us_team.svg
// module id = 190
// module chunks = 0